export const URL_CLASSES = '/classes';
export const URL_TEACHERS = '/teachers';
export const URL_CLASSROOMS = '/classrooms';
export const LINK_TYPE_INTERNAL = 1;
export const LINK_TYPE_EXTERNAL = 2;
export const SCHEDULE_TYPE_CLASS = 1;
export const SCHEDULE_TYPE_TEACHER = 2;
export const SCHEDULE_TYPE_CLASSROOM = 3;
export const MOBILE_WIDTH = 768;
export const VITE_YANDEX_SMART_CAPTCHA_KEY = 'ysc1_KCuDdoaEQ4R9ylvZm0iindCX1H5vZlcNd20Te8Judcdcff3d';